import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const HomeTypeIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="17" fill="none" viewBox="0 0 19 17" className={className} onClick={onClick}>
      <path stroke="#000" d="M5.454 3.728V5.09M8.182 3.727v1.364M5.454 6.455v1.363M8.182 6.455v1.363M5.454 9.182v1.363M8.182 9.182v1.363M2.728 15.318V1h8.181v14.318M0 16h18.41M11.59 4.41h4.092v10.908" ></path>
    </svg>
  );
};

export default HomeTypeIcon;
